export const booleanOptions = [
  {value: true, label: 'Ja'},
  {value: false, label: 'Nej'},
]
